module.exports = __webpack_public_path__ + "static/media/bio_age_ris_ass_pla_sa.2874099c.png";